import { createSlice } from "@reduxjs/toolkit"
import logger from "../Logger"
import { PRINTABLE_REPORT_TYPE } from "../utilities/constants"

const pageLogger = logger.child({ store: "game-report" })
const GameReportSlice = createSlice({
  name: "GAME_REPORT",
  initialState: {
    reportData: {
      initialReport: null,
      modifiedReport: null,
      rawReportData: null,
    },
    printableReport: PRINTABLE_REPORT_TYPE.GENERATED_REPORT,
  },
  reducers: {
    setInitialReport: (state, action) => {
      const { reportData } = action.payload
      // Creating a deep Copy of response
      state.reportData.initialReport = JSON.parse(JSON.stringify(reportData))
    },

    setModifiedReport: (state, action) => {
      const { reportData } = action.payload
      // Creating a deep Copy of response
      state.reportData.modifiedReport = JSON.parse(JSON.stringify(reportData))
    },

    setReportToPrint: (state, action) => {
      const reportType = action.payload
      pageLogger.info({ reportType }, "Report Type recieved")
      state.printableReport = reportType
    },

    setRawReportData: (state, action) => {
      const rawReportData = action.payload
      pageLogger.info({ rawReportData }, "Raw Report Data recieved")
      state.reportData.rawReportData = rawReportData
    },
  },
})

export const GameReportActions = GameReportSlice.actions

export default GameReportSlice
